module.exports = "https://r.nearpod.com/assets/media/image/success-icon-daf606f8a663dbb21379a05cb8983e9c.svg";